document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.joe-imgs-contrast_wrapper');

  // 创建视口观察器
  const carouselObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 当轮播图进入视口时，初始化该轮播图
        initCarousel(entry.target);
        // 初始化后取消观察此轮播图
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '200px', // 提前200px开始加载
    threshold: 0.1      // 当10%的元素可见时触发
  });
  
  // 开始观察所有轮播图
  carousels.forEach(carousel => {
    carouselObserver.observe(carousel);
  });
  
  function initCarousel(carousel){
     const sectionId = carousel.getAttribute('data-section-id');
      
    // 获取必要的DOM元素
      const container = carousel.querySelector(`#grid-slidshow_items-${sectionId}`);
      const beforeImage = container.querySelector('.joe-imgs-contrast_before-img');
      const sliderHandle = container.querySelector('.joe-imgs-contrast_handle');
      
      // 拖动状态跟踪
      let isDragging = false;
      
      // 更新滑块和Before图片位置的函数
      function updateSliderPosition(x) {
        // 获取容器位置信息
        const containerRect = container.getBoundingClientRect();
        
        // 计算相对位置百分比
        let position = (x - containerRect.left) / containerRect.width * 100;
        
        // 限制在0-100%范围内
        position = Math.max(0, Math.min(100, position));
        
        // 更新滑块位置
        sliderHandle.style.left = `${position}%`;
        
        // 更新Before图片宽度
        beforeImage.style.width = `${position}%`;
      }
      
      // === 鼠标事件处理 ===
      // 鼠标按下时开始拖动
      sliderHandle.addEventListener('mousedown', (e) => {
        isDragging = true;
        e.preventDefault(); // 防止选择文本
      });
      
      // 鼠标移动时更新位置
      carousel.addEventListener('mousemove', (e) => {
        if (isDragging) {
          updateSliderPosition(e.clientX);
          e.preventDefault(); // 防止选择文本
        }
      });
      
      // 鼠标释放时结束拖动
      carousel.addEventListener('mouseup', () => {
        isDragging = false;
      });
      
      // 鼠标离开页面时结束拖动
      carousel.addEventListener('mouseleave', () => {
        isDragging = false;
      });
      
      // === 触摸事件处理（移动端支持）===
      // 触摸开始时开始拖动
      sliderHandle.addEventListener('touchstart', (e) => {
        isDragging = true;
        e.preventDefault(); // 防止滚动
      }, { passive: false });
      
      // 触摸移动时更新位置
      carousel.addEventListener('touchmove', (e) => {
        if (isDragging && e.touches[0]) {
          updateSliderPosition(e.touches[0].clientX);
          e.preventDefault(); // 防止滚动
        }
      }, { passive: false });
      
      // 触摸结束时结束拖动
      carousel.addEventListener('touchend', () => {
        isDragging = false;
      });
      
      // === 键盘支持 ===
      // 添加键盘控制支持
      carousel.addEventListener('keydown', (e) => {
        // 获取当前滑块位置
        const currentPosition = parseFloat(sliderHandle.style.left) || 50;
        
        // 检测左右箭头键
        switch(e.key) {
          case 'ArrowLeft':
            // 向左移动滑块 5%
            updateSliderPosition(
              container.getBoundingClientRect().left + 
              container.offsetWidth * (Math.max(0, currentPosition - 5)) / 100
            );
            e.preventDefault();
            break;
          case 'ArrowRight':
            // 向右移动滑块 5%
            updateSliderPosition(
              container.getBoundingClientRect().left + 
              container.offsetWidth * (Math.min(100, currentPosition + 5)) / 100
            );
            e.preventDefault();
            break;
        }
      });
      
      // === 初始设置 ===
      // 确保初始状态正确
      sliderHandle.style.left = '50%';
      beforeImage.style.width = '50%';
      
      // 窗口大小改变时重新计算
      window.addEventListener('resize', () => {
        // 获取当前百分比位置
        const currentPosition = parseFloat(sliderHandle.style.left);
        // 如果有有效位置，则维持当前百分比
        if (!isNaN(currentPosition)) {
          sliderHandle.style.left = `${currentPosition}%`;
          beforeImage.style.width = `${currentPosition}%`;
        }
      });
  }
      
    });